<div
  class="attribute-editor-component icon-container scrollable-component-container scrollable-component-settings"
>
  <div class="attribute-editor-row">
    <label class="control-label icon-label" for="te-icon-search">Icon:</label>
    <mat-form-field
      appearance="outline"
      class="tw-w-full"
      subscriptSizing="dynamic"
    >
      <input
        matInput
        id="te-icon-search"
        type="text"
        placeholder="Search icon"
        [(ngModel)]="filterText"
      />
    </mat-form-field>
  </div>

  <div class="attribute-editor-row">
    <label
      class="control-label icon-label"
      id="te-icon-color-label"
      for="te-icon-color"
      >Color:</label
    >
    <color-picker
      pickerId="te-icon-color"
      placeholderText="Default"
      [(ngModel)]="color"
      (ngModelChange)="onColorChange()"
      ngDefaultControl
      [ariaLabelledby]="'te-icon-color-label'"
    ></color-picker>
  </div>

  <div class="attribute-editor-row icon-grid-row">
    <div class="icon-grid" role="listbox" aria-label="Icon">
      @for (icon of filteredIcons; track icon) {
        <button
          type="button"
          class="icon-option"
          [class.icon-option--selected]="icon === name"
          role="option"
          [attr.aria-selected]="icon === name"
          [attr.aria-label]="icon"
          [title]="icon"
          (click)="selectIcon(icon)"
        >
          <i class="fa fa-{{ icon }}" aria-hidden="true"></i>
        </button>
      }
    </div>
  </div>
</div>
